import { AttributeFilter } from 'app/shared/ui/models/attribute-filter';
import { TranslateService } from '@ngx-translate/core';

export class PaiementMethodAttributeFilter implements AttributeFilter {
  attribute: string;
  label: string;
  operator: string;
  value?: string;
  tempValue?: string | undefined;
  secondValue?: any;
  translateService?: TranslateService;

  constructor(attribute: string, label: string, operator: string, value?: string, secondValue?: any, translateService?: TranslateService) {
    this.attribute = attribute;
    this.label = label;
    this.operator = operator;
    this.value = value;
    this.secondValue = secondValue;
    this.translateService = translateService;
  }

  updateValue(): any {
    const filters = Object.create({});
    this.value = this.tempValue;
    filters[this.attribute + '.' + this.operator] = this.value;
    return filters;
  }

  isChecked(): boolean {
    if (this.tempValue && this.operator) {
      return true;
    } else {
      return false;
    }
  }

  htmlButtonText(): string {
    let htmlContent = '<b>' + this.label + '</b> ';
    htmlContent += this.translateService!.instant(`filters.operators.${this.operator}`);
    htmlContent += '<b>' + this.translateService!.instant(`filters.payment-method.${this.value}`) + '</b> ';
    return htmlContent;
  }
}
